const firebaseConfig = {
    apiKey: "AIzaSyDgx_y79UULjHesjKoVuwExFSLg9Tf2VzA",
    authDomain: "e-notifybrowser.firebaseapp.com",
    projectId: "e-notifybrowser",
    storageBucket: "e-notifybrowser.firebasestorage.app",
    messagingSenderId: "448512922057",
    appId: "1:448512922057:web:ecd4fa6ae2b08284b75818",
    measurementId: "G-ZG91LLDQLJ"
  };

export default firebaseConfig